export interface AcceptOfficialAcceptCollectionRequest {
  collections: {
    id: number
    collectionType: string
    handlingType: string
    acceptDate: string
    mark: string
    ndc: string
    book: string
    sub: string
    publishDate: string
    shelfType: string
    appendixCode: string
    acceptPrice: number
    traderCode: string
    revision: number
    _reserveAssign?: boolean
  }[]
  _isUpdateChildCollection: boolean
}

export function AcceptOfficialAcceptCollectionRequestToJSON(
  value: AcceptOfficialAcceptCollectionRequest
): any {
  return {
    collections: value.collections.map(value => {
      return {
        id: value.id !== 0 ? value.id : undefined,
        collection_type:
          value.collectionType !== '' ? value.collectionType : undefined,
        handling_type:
          value.handlingType !== '' ? value.handlingType : undefined,
        accept_date: value.acceptDate !== '' ? value.acceptDate : undefined,
        mark: value.mark !== '' ? value.mark : undefined,
        ndc: value.ndc !== '' ? value.ndc : undefined,
        book: value.book !== '' ? value.book : undefined,
        sub: value.sub !== '' ? value.sub : undefined,
        publish_date: value.publishDate !== '' ? value.publishDate : undefined,
        shelf_type: value.shelfType !== '' ? value.shelfType : undefined,
        appendix_code:
          value.appendixCode !== '' ? value.appendixCode : undefined,
        accept_price: value.acceptPrice ? value.acceptPrice : undefined,
        trader_code: value.traderCode !== '' ? value.traderCode : undefined,
        revision: value.revision ? value.revision : undefined,
        _reserve_assign: value._reserveAssign ?? undefined
      }
    }),
    _is_update_child_collection: value._isUpdateChildCollection ?? undefined
  }
}
